module.exports = __webpack_public_path__ + "img/loading.30c0aa7.gif";